/**
 * Your own permissions, role and discount limit are the owner's to set.
 *
 * A manager holding "Manage employees" could open their own row and clear their
 * own discount limit (audit 2026-09-23). The API now refuses that with
 * `owner_only` (`EmployeesService.update`), so the drawer shows those fields
 * read-only on your own row rather than offering an edit that can only be
 * refused. Name, phone, photo and username stay yours to change.
 *
 * The owner's own row is read-only for a different reason (they hold every
 * permission) and is not this rule's business, which is why an owner on either
 * side of the comparison answers false.
 */
export function ownPrivilegesLocked(
  row: { id: string; isOwner: boolean } | null,
  signedIn: { id: string; isOwner: boolean } | null,
): boolean {
  if (!row || !signedIn) return false;
  return !row.isOwner && !signedIn.isOwner && row.id === signedIn.id;
}
